import { createAction } from 'typesafe-actions';
import { IdType } from '@rootCommon/types/common';

export const setSelectedOrganizationId = createAction('SET_SELECTED_ORGANIZATION_ID')<IdType>();
export const clearSelectedOrganizationId = createAction('CLEAR_SELECTED_ORGANIZATION_ID')<void>();

export const setSelectedSiteId = createAction('SET_SELECTED_SITE_ID')<IdType>();
export const clearSelectedSiteId = createAction('CLEAR_SELECTED_SITE_ID')<void>();
